import { render, staticRenderFns } from "./ClientIncomeHandler.vue?vue&type=template&id=7e7af07e&scoped=true&"
import script from "./ClientIncomeHandler.vue?vue&type=script&lang=js&"
export * from "./ClientIncomeHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7af07e",
  null
  
)

export default component.exports